// Mirror of the analytics service's published contract, limited to what a
// producer needs: the version string and the event shapes. Validation lives on
// the ingest side, so the zod schemas are deliberately not carried here.
//
// events.ts and version.ts are byte-identical copies of the source of truth.
// `bun run check:contract` fails if they drift.

export {
    ALL_EVENT_NAMES,
    CLIENT_EVENT_NAMES,
    SERVER_EVENT_NAMES,
    isAllowedFromSource,
    isEventName
} from './events';

export type {
    ClientEventMap,
    EventMap,
    EventName,
    EventProps,
    EventSource,
    Money,
    Platform,
    ServerEventMap
} from './events';

export { CONTRACT_VERSION } from './version';
